import React, { createContext, useContext, useRef } from 'react';

const ContentScrollContext =
  createContext<React.RefObject<HTMLDivElement | null> | null>(null);

export function useContentScrollRef(): React.RefObject<HTMLDivElement | null> | null {
  return useContext(ContentScrollContext);
}

type ContentScrollProviderProps = {
  children: React.ReactNode;
};

export function ContentScrollProvider({
  children,
}: ContentScrollProviderProps) {
  const ref = useRef<HTMLDivElement>(null);
  return (
    <ContentScrollContext.Provider value={ref}>
      {/*
       * overscroll-none: stop the elastic rubber-band at the top/bottom, which
       * otherwise bounces sticky list headers that live inside this scroller.
       *
       * scrollbar-gutter:stable: always reserve the scrollbar's track, so content
       * that grows past the viewport doesn't yank the layout sideways as the bar
       * appears. `*::-webkit-scrollbar { width: 8px }` in styles.css opts the app
       * out of macOS overlay scrollbars, so the bar occupies real layout space —
       * without a reserved gutter, expanding anything tall (a trigger group, a
       * long list) shifts every centered page 4px to the left mid-interaction.
       */}
      <div
        ref={ref}
        className="min-h-0 flex-1 overflow-auto overscroll-none [scrollbar-gutter:stable]"
      >
        {children}
      </div>
    </ContentScrollContext.Provider>
  );
}
